export default function CloseIcon(props: React.SVGProps<SVGSVGElement>) {
  const { color = '#888599' } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 15L12 12M15 9L12 12M12 12L9 9M12 12L15 15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

